import {DraggableTree} from 'vue-draggable-nested-tree'
import Status from '@/status'
import swal from 'sweetalert'
export default {
  name: 'view',
  components: {Tree: DraggableTree},
  props: [],
  data () {
    return {
      loading: false,
      document: {}
    }
  },
  computed: {
    document_items () {
      return this.$store.getters['DocumentItem/getListDocumentItem']
    },
    in_queue () {
      var queues = this.$store.getters['DocumentItem/getDocummentQueue']
      return queues.indexOf(this.$route.params.document_id) !== -1
    }
  },
  mounted () {
  
    // this.loading = true
    Promise.all([
      this.$store.dispatch('Document/showDocument', {document: {id: this.$route.params.document_id}}),
      this.$store.dispatch('DocumentItem/getListDocumentItem', {document: {id: this.$route.params.document_id}})
    ]).then(res => {
      this.document = res[0]
      
      this.loading = false
    }).catch(errors => {
      
      this.loading = false
    })
  },
  beforeRouteUpdate (to, from, next) {
    // ()
    // this.loading = true
    Promise.all([
      this.$store.dispatch('Document/showDocument', {document: {id: this.$route.params.document_id}}),
      this.$store.dispatch('DocumentItem/getListDocumentItem', {document: {id: this.$route.params.document_id}})
    ]).then(res => {
      // 
      next()
      this.loading = false
    }).catch(errors => {
      // 
      this.loading = false
    })
  },
  methods: {
    edit () {
      if (this.document.status.code === parseInt(Status.APPROVAL)) {
        this.$router.push('/document/view/' + this.$route.params.document_id)
      } else {
        swal({
          title: this.$t('document.errors.title'),
          text: this.$t('document.errors.text'),
          icon: 'warning'
        })
      }
    },
    index () {
      if (this.document.status.code === parseInt(Status.APPROVAL)) {
        this.$router.push('/document/view/' + this.$route.params.document_id + '/index')
      } else {
        swal({
          title: this.$t('document.errors.title'),
          text: this.$t('document.errors.text'),
          icon: 'warning'
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/document-item/view/view.js